// React, Next
import { useTranslation } from 'next-i18next'

// Custom
import SlidesSectionModel from '@/components/sections/models/SlidesSectionModel'

// Img
// Placeholder - the same image is used for every slide for now.
import ManufacturingShoopFloor from 'public/img/services/manufacturing_shop_floor.webp'
import MachineBuilder from 'public/img/services/machine_builder.webp'
import OtProjectManager from 'public/img/services/ot_project_managers.webp'
import IndustriualIt from 'public/img/services/industrial_it.webp'
import SystemIntegrator from 'public/img/services/system_integrator.png'
import SmallShopFloor from 'public/img/services/small_shop_floor.png'

export default function IndustriesSection() {
  const { t } = useTranslation('servicesOtCybersecurity')

  const slides = [
    {
      title: t('industries.items.01.title'),
      description: t('industries.items.01.description'),
      img: ManufacturingShoopFloor
    },
    {
      title: t('industries.items.02.title'),
      description: t('industries.items.02.description'),
      img: MachineBuilder
    },
    {
      title: t('industries.items.03.title'),
      description: t('industries.items.03.description'),
      img: OtProjectManager
    },
    {
      title: t('industries.items.04.title'),
      description: t('industries.items.04.description'),
      img: SmallShopFloor
    },
    {
      title: t('industries.items.05.title'),
      description: t('industries.items.05.description'),
      img: IndustriualIt
    },
    {
      title: t('industries.items.06.title'),
      description: t('industries.items.06.description'),
      img: SystemIntegrator
    }
  ]

  // *** MAIN RENDER ***
  return (
    <SlidesSectionModel
      header={t('industries.title')}
      slides={slides}
      marginTop="1rem"
      marginBottom="7rem"
    />
  )
}
